import { InjectionToken } from '@angular/core';
import { ITreatmentColorService } from './treatment-color-service.interface';

export const TREATMENT_COLOR_SERVICE =
  new InjectionToken<ITreatmentColorService>('TREATMENT_COLOR_SERVICE');
